/**
 * @generated SignedSource<<8b7ca49a4cbf70e50ac19f5c3a2fa780>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteRepeatingTaskInput = {
  id: string;
  taskId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteRepeatingTaskMutation$variables = {
  input: DeleteRepeatingTaskInput;
};
export type deleteRepeatingTaskMutation$data = {
  readonly deleteRepeatingTask: {
    readonly task: {
      readonly repeatingTask: {
        readonly id: string;
        readonly repeatType: string | null;
        readonly monday: boolean | null;
        readonly tuesday: boolean | null;
        readonly wednesday: boolean | null;
        readonly thursday: boolean | null;
        readonly friday: boolean | null;
        readonly saturday: boolean | null;
        readonly sunday: boolean | null;
        readonly monthlyDay: number | null;
      } | null;
    } | null;
  } | null;
};
export type deleteRepeatingTaskMutation = {
  variables: deleteRepeatingTaskMutation$variables;
  response: deleteRepeatingTaskMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "RepeatingTask",
  "kind": "LinkedField",
  "name": "repeatingTask",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "repeatType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "monday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tuesday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wednesday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thursday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "friday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "saturday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sunday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "monthlyDay",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteRepeatingTaskMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteRepeatingTaskPayload",
        "kind": "LinkedField",
        "name": "deleteRepeatingTask",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteRepeatingTaskMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteRepeatingTaskPayload",
        "kind": "LinkedField",
        "name": "deleteRepeatingTask",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ef70175bef1100134b3217d7361ad6b7",
    "id": null,
    "metadata": {},
    "name": "deleteRepeatingTaskMutation",
    "operationKind": "mutation",
    "text": "mutation deleteRepeatingTaskMutation(\n  $input: DeleteRepeatingTaskInput!\n) {\n  deleteRepeatingTask(input: $input) {\n    task {\n      repeatingTask {\n        id\n        repeatType\n        monday\n        tuesday\n        wednesday\n        thursday\n        friday\n        saturday\n        sunday\n        monthlyDay\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "73887284304c30da0a31564950f96ecd";

export default node;
